import { render, staticRenderFns } from "./SelectFilter.vue?vue&type=template&id=36fb6675&"
import script from "./SelectFilter.vue?vue&type=script&lang=js&"
export * from "./SelectFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports